document.addEventListener('DOMContentLoaded', function () {
  const faqSection = document.getElementById('faqs')

  if (!faqSection) return

  const questions = faqSection.querySelectorAll('.question')
  const searchInput = document.getElementById('faq-search')
  const faqs = faqSection.querySelectorAll('.faq')
  const faqList = document.getElementById('faq-list')

  // FAQ toggle functionality
  if (questions.length > 0) {
    questions.forEach(question => {
      question.addEventListener('click', function() {
        const faq = this.parentElement
        if (!faq.classList.contains('active')) {
          faqs.forEach(f => {
            f.classList.remove('active')
          })
          faq.classList.add('active')
        } else {
          faq.classList.remove('active')
        }
      })
    })
  }

  // FAQ search functionality
  if (searchInput && faqs.length > 0 && faqList) {
    searchInput.addEventListener('input', function() {
      const searchTerm = this.value.toLowerCase().trim()

      let hasVisibleFaqs = false

      faqs.forEach(faq => {
        const question = faq.querySelector('.question')
        const questionTextSpan = faq.querySelector('.question-text')

        if (!question || !questionTextSpan) return

        // Store original text if not already stored
        if (!questionTextSpan.dataset.originalText) {
          questionTextSpan.dataset.originalText = questionTextSpan.textContent.trim()
        }

        const questionText = questionTextSpan.dataset.originalText.toLowerCase()

        // Check if search term matches question only
        if (searchTerm === '' || questionText.includes(searchTerm)) {
          faq.style.display = ''
          hasVisibleFaqs = true

          // Highlight matching text
          if (searchTerm !== '') {
            const regex = new RegExp(`(${searchTerm})`, 'gi')
            const highlightedText = questionTextSpan.dataset.originalText.replace(regex, '<mark class="bg-yellow-400 text-black">$1</mark>')
            questionTextSpan.innerHTML = highlightedText
          } else {
            // Restore original text
            questionTextSpan.textContent = questionTextSpan.dataset.originalText
          }
        } else {
          faq.style.display = 'none'
        }
      })

      // Show "no results" message if no FAQs are visible
      let noResultsMsg = document.getElementById('faq-no-results')

      if (!hasVisibleFaqs && searchTerm !== '') {
        if (!noResultsMsg) {
          noResultsMsg = document.createElement('p')
          noResultsMsg.id = 'faq-no-results'
          noResultsMsg.className = 'text-center text-white/70 mt-8'
          noResultsMsg.textContent = 'No FAQs found matching your search.'
          faqList.appendChild(noResultsMsg)
        }
        noResultsMsg.style.display = 'block'
      } else if (noResultsMsg) {
        noResultsMsg.style.display = 'none'
      }
    })
  }
})
